import Controller from '@ember/controller';

export default class LocationBillingController extends Controller {}
